<template>
  <div>
    <div class="content">
      <div id="map-content" style="height: 110%;"/>
    </div>
    <div class="mask" />
  </div>
</template>

<script>

import EventBus from '@/event-bus';

export default {
  name: 'BMapVue',
  props: {
    dwList: {
      type: Array,
      default: () => {
        return [
          // {
          //   code: 1,
          //   name: '鸿蒙智慧消防实验室',
          //   dz: '广州市海珠区新港东路1066号一层A7、A8商铺自编1-E01',
          //   lwzt: '0',
          //   zbry: '刘波',
          //   xfaqzrrmc: '江小白',
          //   lng: 113.375879, // 地理经度
          //   lat: 23.103363// 地理纬度
          // }
        ];
      }
    },
    capacityName: {
      type: String,
      default: '' // 人员身份名称
    }
  },
  data () {
    return {
      map: null,
      currentPosition: {},
      pazhouLocation: {
        lng: 113.375426, // 地理经度
        lat: 23.095921, // 地理纬度
        zoom: 15
    }// 琶洲街道
    };
  },
  methods: {
    changeDw (dw) {
      if (dw.lng === this.currentPosition.lng && dw.lat === this.currentPosition.lat) {
        this.map.zoomTo([8494131.155395325, 2776592.772179904], 4);
        this.$parent.changeDetail(false);
        this.currentPosition = {};
      } else {
        this.currentPosition = dw;
        this.map.zoomTo([dw.lng, dw.lat], 6);
      }
    },
    loadMapResources () {
      // 设置全局IP变量
      window.Ip = 'https://map.scut.edu.cn';

      // 加载CSS文件
      this.loadCSS('/css/oMap.css');
      this.loadCSS('/css/mapUtil.css');

      // 按顺序加载JS文件
      const scripts = [
        '/js/proj4.js',
        '/js/ol3Echarts.js',
        '/js/oMap-source.js',
        '/js/mapUtil.js',
        '/js/jquery.min.js',
        '/js/customMap.js'
      ];

      this.loadScriptOne(scripts, 0);
    },

    loadScriptOne (scripts, index) {
      if (index >= scripts.length) {
        // 所有脚本加载完成，确保O_Map已定义后再初始化地图
        setTimeout(() => {
          if (typeof O_Map !== 'undefined') {
            this.initMap();
          } else {
            console.error('O_Map对象未定义，请检查脚本加载情况');
          }
        }, 300); // 添加短暂延迟确保脚本完全执行
        return;
      }

      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => {
        // 加载下一个脚本
        this.loadScriptOne(scripts, index + 1);
      };
      script.onerror = () => {
        console.error(`脚本加载失败: ${scripts[index]}`);
        // 尝试继续加载下一个
        this.loadScriptOne(scripts, index + 1);
      };
      document.head.appendChild(script);
    },

    loadCSS (url) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      document.head.appendChild(link);
    },

    initMap () {
      try {
        this.createMap();
        this.addMapControl();
        this.setMapEvent();
        console.log('地图初始化成功');
      } catch (error) {
        console.error('初始化地图时出错:', error);
      }
    },

    createMap () {
      if (typeof O_Map === 'undefined') {
        throw new Error('O_Map 未定义');
      }
      this.map = O_Map.init('map-content', 0, true, '25D');
      this.map.zoomTo([8494131.155395325, 2776592.772179904], 4);
      window.map = this.map;
    },

    addMapControl () {
      if (this.map) {
        this.map.addMapControl({ logo: false, switchMapControl: false, zoomControl: false });
      }
    },

    setMapEvent () {
      if (this.map) {
        this.map.setMapEvent({ mouseDragEvent: true, mouseWheelZoomEvent: true });
      }
    },
    addMarkers (_markerArrs) {
      const adds = [];
      if (this.map && _markerArrs && _markerArrs.length > 0) {
       _markerArrs.forEach(e => {
         adds.push({ title: e.name, imageUrl: e.imageUrl, all: {botid:e.botid,code:e.code}, index: 1, x: e.lng, y: e.lat, func1: (value) => { EventBus.$emit('MapEmitEvent', value); } });
       });
        this.map.addMarker(adds);
      }
    },
    addMarkersWithOutName (_markerArrs) {
      const adds = [];
      if (this.map && _markerArrs && _markerArrs.length > 0) {
        _markerArrs.forEach(e => {
          adds.push({ title: '',
            imageUrl: e.imgUrl,
            index: 1,
            x: e.dzLng,
            y: e.dzLat,
            sslxmc: e.sslxmc,
            azwz: e.azwz,
            bjmc: e.bjmc,
            sszt: e.sszt
          });
        });
        this.map.addMarkerWithOutName(adds);
      }
    },
    addxlry (_markerArrs) {
      const adds = [];
      if (this.map && _markerArrs && _markerArrs.length > 0) {
        _markerArrs.forEach(e => {
          adds.push({ title: e.title,
            imageUrl: e.imgUrl,
            index: 1,
            x: e.dzLng,
            y: e.dzLat,
            sslxmc: e.sslxmc,
            azwz: e.azwz,
            bjmc: e.bjmc,
            gw: e.gw
          });
        });
        this.map.addxlry(adds);
      }
    },
    cleanFireHydrant(){
      this.map.cleanFireHydrant();
    }
  },
  beforeUnmount () {
    if (this.map) {
      this.map = null;
      window.map = null;
    }
    EventBus.$off('MapEmitEvent');
  },
  mounted () {
    this.loadMapResources();
  }
};
</script>

<style lang="scss">

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial, sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
}

.content {
  height: 100%;
  text-align: center;
  z-index: 1; /* 确保内容在遮罩之下 */
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* 允许点击穿透到下层 */
  z-index: 10;

  /* 关键部分：使用径向渐变创建自然过渡的椭圆镂空 */
  background: radial-gradient(
      ellipse 1000px 450px at center,
      transparent 0%,       /* 中心完全透明 */
      transparent 50%,      /* 40%位置仍然透明 */
      rgba(0, 0, 0, 0.2) 75%,  /* 50%位置开始有轻微黑色 */
      rgba(0, 0, 0, 0.3) 80%,  /* 60%位置渐变加深 */
      rgba(0, 0, 0, 0.4) 85%,  /* 70%位置更深 */
      rgba(0, 0, 0, 0.5) 90%,  /* 80%位置接近最终颜色 */
      rgba(0, 0, 0, 0.6) 100%  /* 边缘最深 */
  );

  /* 添加额外的黑色背景 */
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6);
}

.richWrapper * {
  padding: 0;
  margin: 0;
}

.richWrapper {
  box-sizing: border-box;
  width: 336px;
  height: 206px;
  padding: 10px 10px;
  background: url('/monitor/images/richMaker_dialog.png') no-repeat center center;
  background-size: cover;
}

.richTitle {
  width: 100%;
  height: 45px;
  padding: 0 0 0 16px;
  font-family: MicrosoftYaHei-Bold;
  font-size: 16px;
  font-weight: 600;
  line-height: 45px;
  color: #fffefe;
}

.richContent li {
  display: flex;
  justify-content: space-between;
  height: 30px;
  list-style: none;
}

.richContent {
  padding: 10px 20px 20px 20px;

  &-left {
    flex-shrink: 0;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0;
    color: #daf0ff;
  }

  &-right {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0;
    color: #5afff7;
  }
}
</style>
